(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wylen-buybar"] && !Shopify.designMode) return;
  try {
    
/* Wylen storefront behaviour. Small on purpose: photo dots, the 1 or 2 sets choice, the sticky buy bar, scroll reveal, delivery dates. */
(function () {
  'use strict';
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia('(max-width: 799px)');

  // Dots under the product photos
  var track = document.getElementById('wy-gtrack');
  if (track) {
    var dots = document.querySelectorAll('#wy-gdots span');
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth) || 0;
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    }, { passive: true });
  }

  // 1 set or 2 sets: set the quantity the form sends and the price shown on the buttons
  var qty = document.querySelector('[data-wy-qty]');
  function setOffer(input) {
    if (qty) qty.value = input.value;
    document.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = input.getAttribute('data-wy-price'); });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'wy-offer') setOffer(e.target);
  });
  var chosen = document.querySelector('input[name="wy-offer"]:checked');
  if (chosen) setOffer(chosen);

  // Buy now: the form sends the shopper straight to checkout. Empty the cart first, so the checkout holds only
  // what the shopper chose on this page (1 set or 2 sets) and never a leftover from an earlier visit.
  var form = document.getElementById('wy-product-form');
  if (form && form.querySelector('input[name="return_to"]') && window.fetch) {
    var sent = false, busy = false;
    var buyButtons = function () { return document.querySelectorAll('button[type="submit"][form="wy-product-form"], #wy-product-form button[type="submit"]'); };
    var send = function () {
      if (sent) return;
      sent = true;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    };
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button[type="submit"]') : null;
      if (!b || b.form !== form || sent) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      buyButtons().forEach(function (x) { x.setAttribute('aria-busy', 'true'); });
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      setTimeout(send, 2000);
      try {
        fetch(root + 'cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(send, send);
      } catch (err) { send(); }
    });
    // Back button: the browser can show the page again from memory. Make the buttons work again.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      sent = false; busy = false;
      buyButtons().forEach(function (x) { x.removeAttribute('aria-busy'); });
    });
  }

  // Sticky buy bar: shows on phones once the page's main button has scrolled off the top
  var bar = document.getElementById('wy-buybar');
  var anchor = document.getElementById('wy-buyrow') || document.getElementById('wy-hero-cta');
  if (bar && anchor) {
    var past = false;
    var update = function () { bar.hidden = !(past && phone.matches); };
    var check = function () { var r = anchor.getBoundingClientRect(); past = r.height > 0 && r.bottom < 0; update(); };
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; update(); }).observe(anchor);
    }
    check();
  }

  // Scroll reveal for rows marked .rv (only rows that start below the screen are held back)
  if ('IntersectionObserver' in window && !calm.matches) {
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.remove('rv--wait');
        en.target.classList.add('rv--in');
        seen.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
    document.querySelectorAll('.wy .rv').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (!(r.height > 0 && r.top < window.innerHeight && r.bottom > 0)) el.classList.add('rv--wait');
      seen.observe(el);
    });
  }

  // Clips: people who switch off motion get a still frame with play controls
  if (calm.matches) document.querySelectorAll('.wy .clips video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); v.controls = true; });

  // Delivery window: 7 to 12 working days from today (weekends skipped, bank holidays not)
  var eta = document.getElementById('wy-eta');
  if (eta) {
    try {
      var add = function (from, n) { var d = new Date(from); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; } return d; };
      var fmt = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
      var now = new Date();
      eta.textContent = 'Order today and it arrives between ' + fmt.format(add(now, 7)) + ' and ' + fmt.format(add(now, 12));
    } catch (e) {}
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wylen-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-wy-carousel]').forEach(function (box) {
    if (box._wy) return;
    box._wy = true;
    var track = box.querySelector('.rc__track');
    if (!track || track.children.length < 2) return;
    var quiet = false, wake = null;
    function step(d) {
      var w = track.children[0].getBoundingClientRect().width + 12;
      var max = track.scrollWidth - track.clientWidth;
      var cur = track.scrollLeft, next = cur + d * w;
      if (d > 0 && cur >= max - 4) next = 0;
      else if (d < 0 && cur <= 4) next = max;
      track.scrollTo({ left: next, behavior: 'smooth' });
    }
    function rest() {
      quiet = true;
      clearTimeout(wake);
      wake = setTimeout(function () { quiet = false; }, 9000);
    }
    ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach(function (ev) {
      track.addEventListener(ev, rest, { passive: true });
    });
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wy-rc]');
      if (!b) return;
      step(Number(b.getAttribute('data-wy-rc')));
      rest();
    });
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setInterval(function () { if (!quiet && !document.hidden) step(1); }, 4500);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
